/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/background/background_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ BACKGROUND : CHILD ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class Background extends Component {
	constructor(props) {
		super(props);
		let bgImage = 'none';
		let bgColor;
		this.isScreen = false;
		if(!!props.screenBGImg) {
			this.isScreen = true;
			bgImage = props.screenBGImg === 'none' || !props.screenBGImg ? 'none' : `url(${props.screenBGImg})`;
            bgColor = !!props.screenBGColor ? props.screenBGColor : 'rgba(48,48,48,0.8)';
		} else if (this.props.currentContentData.data[this.props.currentContentStatus.frame] !== undefined) {
			const dataBGColor = this.props.currentContentData.data[this.props.currentContentStatus.frame].backgroundColor;
			const bgImageSrc = this.props.currentContentData.data[this.props.currentContentStatus.frame].background;
			bgImage = !!bgImageSrc ? `url(${url.image.client}${bgImageSrc})` : `none`;
			if ((dataBGColor === null) || (dataBGColor === undefined)) {
				bgColor = 'rgba(48,48,48,0.8)';
			} else {
				bgColor = this.props.currentContentData.data[this.props.currentContentStatus.frame].backgroundColor;
			}
		}
		this.state = {
			inlineStyles: { 'background-image': bgImage },
			fadeStyles: { background: bgColor }
		};
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.currentContentData.data[this.props.currentContentStatus.frame] !== undefined &&
            nextProps.currentContentData.data[nextProps.currentContentStatus.frame] !== undefined) {
			let currSrc = this.props.currentContentData.data[this.props.currentContentStatus.frame].background;
			let nextSrc = nextProps.currentContentData.data[nextProps.currentContentStatus.frame].background;
			let currColor = this.props.currentContentData.data[this.props.currentContentStatus.frame].backgroundColor;
			let nextColor = nextProps.currentContentData.data[nextProps.currentContentStatus.frame].backgroundColor;
			if (currSrc !== nextSrc) {
				this.setState({
					inlineStyles: nextSrc !== null ? { 'background-image': `url(${url.image.client}${nextSrc})` } : { 'background-image': `none` },
					fadeStyles: { background: nextColor !== null ? nextColor : 'rgba(48,48,48,0.8)' }
				});
			} else if (currColor !== nextColor) {
				this.setState({
					fadeStyles: { background: nextColor !== null ? nextColor : 'rgba(48,48,48,0.8)' }
				});
			}
		}
        if(this.props.currentContentStatus.type === 'userDataCollection' &&
            this.props.screenBGImg !== nextProps.screenBGImg || this.props.screenBGColor !== nextProps.screenBGColor) {
            this.setState({
                inlineStyles: nextProps.screenBGImg !== null || nextProps.screenBGImg !== 'none' ?
					{ 'background-image': `url(${url.image.client}${nextProps.screenBGImg})` } : { 'background-image': `none` },
                fadeStyles: { background: !!nextProps.screenBGColor ? nextProps.screenBGColor : 'rgba(48,48,48,0.8)' }
            })

        }
	}
	render() {
	    return(
	    	<div className={`${sheet.classes.background} background bgContentType-${this.props.currentContentStatus.type} abTestVersion-${this.props.abTestVersion}`}>
		    	<div className={`${sheet.classes.fade} fade`} style={this.state.fadeStyles} />
		    	<div className={`${sheet.classes.image} image`} style={this.state.inlineStyles} />
		    </div>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Background;
